// The options a page opened with options of its own (initialOptions) starts
// from. A catalog name's url (keepLocalStorageOptions) sets only its technical
// properties, over the customer's own dimensions and material stored in the
// browser; any other url's options stand alone.
const initialUserOptions = (initialOptions, localStorageOptions) => {
  const { keepLocalStorageOptions, ...options } = initialOptions;
  if(!keepLocalStorageOptions || !localStorageOptions) { return options }

  const userOptions = { ...localStorageOptions, ...options };
  userOptions.advancedOptionsVisible = Boolean(localStorageOptions.advancedOptionsVisible || options.advancedOptionsVisible);
  return userOptions;
};

export default initialUserOptions;
